import axios from "axios";

// const APIBaseUrl = "http://192.168.1.6:8002/shambasync/v1";
// const APIBaseUrl = "https://shambasync-api.dextragroups.com/shambasync/v1";
// const APIBaseUrl = "http://72.60.218.159/shambasync/v1";
const APIBaseUrl = "https://shambasync-api.dextragroups.com/shambasync/v1";

export const productParticular = async (path, params = {}) => {
    try {
        const response = await axios.get(`${APIBaseUrl}${path}`, {
            params,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("GET API Error:", error);
        return error?.response?.data || { message: "Unknown error", statusCode: 500 };
    }
};


export const postWithoutTokenAPI = async (path, payload) => {
    try {
        const isFormData = payload instanceof FormData;

        const headers = {
            Accept: 'application/json',
        };

        // Only set 'Content-Type' if payload is not FormData
        if (!isFormData) {
            headers['Content-Type'] = 'application/json';
        }

        const response = await axios.post(`${APIBaseUrl}${path}`, payload, { headers });

        return response.data;
    } catch (error) {
        // Handle error appropriately
        console.error('API request failed:', error);
        return { error: error };
    }
};

// export const postWithTokenAPI = async (token, path, payload) => {
//     try {
//       const isFormData = payload instanceof FormData;

//       const headers = {
//         Accept: 'application/json',
//         Authorization: 'Bearer ' + token,
//       };

//       // Only set 'Content-Type' if payload is not FormData
//       if (!isFormData) {
//         headers['Content-Type'] = 'application/json';
//       }

//       const response = await axios.post(`${APIBaseUrl}${path}`, payload, { headers });

//       return response.data;
//     } catch (error) {
//       // Handle error appropriately
//       console.error('API request failed:', error);
//       return { error: error };
//     }
// };


export const postWithTokenAPI = async (token, path, payload) => {
    try {
        const isFormData = payload instanceof FormData;

        const headers = {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        };

        // Only set 'Content-Type' if payload is NOT FormData
        if (!isFormData) {
            headers["Content-Type"] = "application/json";
        }

        const response = await axios.post(`${APIBaseUrl}${path}`, payload, {
            headers,
        });

        return response.data; // Only return the data from the response
    } catch (error) {
        console.error("API request failed:", error);
        return { error: error.message || "Unknown error" }; // return error object for easier handling
    }
};

export const mypostWithTokenAPI = async (url, body) => {
    const token = localStorage.getItem('token');
    const response = await fetch(APIBaseUrl + url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(body)
    });
    return response.json();
};

export const getWithTokenAPI = async (token, path) => {
    const response = await axios
        .get(`${APIBaseUrl}` + path, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            },
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => ({ error: error }));
    return response;
};

export const getWithoutTokenAPI = async (path) => {
    const response = await axios
        .get(`${APIBaseUrl}` + path, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => ({ error: error }));
    return response;
};

export const putAPI = async (token, path, payload) => {
    const response = await axios
        .put(`${APIBaseUrl}` + path, payload, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            },
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => ({ error: error }));
    return response;
};



// export const putAPI = async (token, path, payload, isFormData = false) => {
//   const headers = {
//     Accept: "application/json",
//     Authorization: "Bearer " + token,
//   };

//   if (!isFormData) {
//     headers["Content-Type"] = "application/json";
//   }
//   // If isFormData is true, let axios handle multipart header

//   const response = await axios
//     .put(`${APIBaseUrl}` + path, payload, { headers })
//     .then((response) => response.data)
//     .catch((error) => ({ error }));

//   return response;
// };


export const putwithoutAPI = async (path, data) => {
    try {
        const response = await axios.put(`${APIBaseUrl}${path}`, data, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("PUT API Error:", error);
        return error?.response?.data || { message: "Unknown error", statusCode: 500 };
    }
};
export const deleteAPI = async (token, path, payload) => {
    const response = await axios
        .delete(`${APIBaseUrl}` + path, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            },
            data: payload
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => ({ error: error }));
    return response;
};
// export const deleteAPI = async (token, path, payload) => {
//     const response = await axios
//       .delete(`${APIBaseUrl}${path}`, {
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "application/json",
//           "Authorization": `Bearer ${token}`,
//         },
//         data: payload // the actual body for the DELETE request
//       })
//       .then((response) => response.data)
//       .catch((error) => ({ error }));

//     return response;
//   };

// export const deleteAPI = (token, url, data = {}) => {
//     return axios.delete(url, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         'Content-Type': 'application/json',
//       },
//       data,
//     });
//   };


// export const UploadDocument = async (Payload) => {
//     const response = await axios
//       .post(`${application_url}/upload`, Payload, {
// headers: {
//   Accept: "application/json",
//   "Content-Type": "application/json",
// },
//       })
//       .then((response) => {
//         return response.data;
//       })
//       .catch((error) => ({ error: error }));
//     return response;
// };

export const UploadDocument = async (path, data) => {
    const response = await axios
        .put(`${APIBaseUrl}${path}`, data, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => ({ error: error }));
    return response;
};